import { useMemo } from 'react';
import { getStockLevelCounts } from '../../../../utils/stockUtils';

function useInventory({ isFinishedGoodsStock, isRawMaterialStock, filteredFinishedGoodsStock, filteredRawMaterialStock, filteredStock, settings }) {
  const stockRows = useMemo(() => (
    isFinishedGoodsStock
      ? filteredFinishedGoodsStock
      : (isRawMaterialStock ? filteredRawMaterialStock : filteredStock)
  ), [filteredFinishedGoodsStock, filteredRawMaterialStock, filteredStock, isFinishedGoodsStock, isRawMaterialStock]);

  const stockCounts = useMemo(() => getStockLevelCounts(stockRows, settings), [settings, stockRows]);

  const totalStockQuantity = useMemo(
    () => stockRows.reduce((sum, item) => sum + (parseFloat(item.current_stock) || 0), 0),
    [stockRows]
  );

  return {
    stockCounts,
    stockRows,
    totalStockQuantity
  };
}

export default useInventory;
